import { Routes, Route, useLocation } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import Home from './pages/Home'
import Anuncios from './pages/Anuncios'
import AnuncioDetalhe from './pages/AnuncioDetalhe'
import Login from './pages/Login'
import Cadastro from './pages/Cadastro'
import CompletarPerfil from './pages/CompletarPerfil'
import AdicionarTipo from './pages/AdicionarTipo'
import MinhasCompras from './pages/MinhasCompras'
import MeusFavoritos from './pages/MeusFavoritos'
import FretesDisponiveis from './pages/FretesDisponiveis'
import MinhasCandidaturas from './pages/MinhasCandidaturas'
import MotoristaLanding from './pages/MotoristaLanding'
import MinhasConversas from './pages/MinhasConversas'
import MeusAnuncios from './pages/MeusAnuncios'
import CriarAnuncio from './pages/CriarAnuncio'
import EditarAnuncio from './pages/EditarAnuncio'
import Perfil from './pages/Perfil'
import MotoristasLista from './pages/MotoristasLista'
import Ajuda from './pages/Ajuda'
import TermosUso from './pages/TermosUso'
import PoliticaPrivacidade from './pages/PoliticaPrivacidade'
import Lgpd from './pages/Lgpd'
import Cotacoes from './pages/Cotacoes'
import ChatWindow from './components/ChatWindow'
import { useChat } from './contexts/ChatContext'
import { useSocket } from './contexts/SocketContext'
import { useState, useEffect } from 'react'
import NotificationCard from './components/NotificationCard'
import ScrollToTop from './components/ScrollToTop'

import AdminLayout from './pages/admin/AdminLayout'
import AdminDashboard from './pages/admin/AdminDashboard'
import AdminUsuarios from './pages/admin/AdminUsuarios'
import AdminAnuncios from './pages/admin/AdminAnuncios'
import AdminFinanceiro from './pages/admin/AdminFinanceiro'
import AdminCupons from './pages/admin/AdminCupons'
import AdminLogs from './pages/admin/AdminLogs'
import AdminMotoristas from './pages/admin/AdminMotoristas'

function App() {
    const { isOpen, activeChat, closeChat, openChat } = useChat()
    const { socket } = useSocket()
    const [notificacao, setNotificacao] = useState(null)
    const location = useLocation()

    const isAdmin = location.pathname.startsWith('/admin')

    useEffect(() => {
        if (!socket) return;

        const handleNovaMensagem = (msg) => {
            // Só notifica se o chat com essa pessoa não estiver aberto no momento
            if (!isOpen || activeChat?.id !== msg.remetente_id) {
                setNotificacao(msg);
            }
        };

        socket.on('nova_mensagem', handleNovaMensagem);

        return () => {
            socket.off('nova_mensagem', handleNovaMensagem);
        };
    }, [socket, isOpen, activeChat]);

    return (
        <div className="app">
            <ScrollToTop />
            {!isAdmin && <Header />}
            {!isAdmin ? (
                <main className="main-content">
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/anuncios" element={<Anuncios />} />
                        <Route path="/motoristas" element={<MotoristasLista />} />
                        <Route path="/anuncio/:id" element={<AnuncioDetalhe />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/cadastro" element={<Cadastro />} />
                        <Route path="/completar-perfil" element={<CompletarPerfil />} />
                        <Route path="/adicionar-tipo" element={<AdicionarTipo />} />
                        <Route path="/perfil" element={<Perfil />} />

                        {/* Rotas de Comprador */}
                        <Route path="/minhas-compras" element={<MinhasCompras />} />
                        <Route path="/meus-favoritos" element={<MeusFavoritos />} />

                        {/* Rotas de Fretes */}
                        <Route path="/area-motorista" element={<MotoristaLanding />} />
                        <Route path="/fretes-disponiveis" element={<FretesDisponiveis />} />
                        <Route path="/minhas-candidaturas" element={<MinhasCandidaturas />} />
                        <Route path="/minhas-conversas" element={<MinhasConversas />} />


                        {/* Rotas de Vendedor */}
                        <Route path="/meus-anuncios" element={<MeusAnuncios />} />
                        <Route path="/criar-anuncio" element={<CriarAnuncio />} />
                        <Route path="/editar-anuncio/:id" element={<EditarAnuncio />} />

                        {/* Ajuda e Páginas Legais */}
                        <Route path="/ajuda" element={<Ajuda />} />
                        <Route path="/termos-de-uso" element={<TermosUso />} />
                        <Route path="/politica-de-privacidade" element={<PoliticaPrivacidade />} />
                        <Route path="/lgpd" element={<Lgpd />} />
                        <Route path="/cotacoes" element={<Cotacoes />} />
                    </Routes>
                </main>
            ) : (
                <Routes>
                    {/* Rotas Admin */}
                    <Route path="/admin" element={<AdminLayout />}>
                        <Route index element={<AdminDashboard />} />
                        <Route path="usuarios" element={<AdminUsuarios />} />
                        <Route path="motoristas" element={<AdminMotoristas />} />
                        <Route path="anuncios" element={<AdminAnuncios />} />
                        <Route path="financeiro" element={<AdminFinanceiro />} />
                        <Route path="cupons" element={<AdminCupons />} />
                        <Route path="logs" element={<AdminLogs />} />
                    </Route>
                </Routes>
            )}
            {!isAdmin && <Footer />}

            {isOpen && activeChat && (
                <ChatWindow outroUsuario={activeChat} onClose={closeChat} />
            )}

            {notificacao && (
                <NotificationCard 
                    mensagem={notificacao} 
                    onClose={() => setNotificacao(null)} 
                    onResponder={() => openChat({ id: notificacao.remetente_id, nome: notificacao.remetente_nome, foto: notificacao.remetente_foto })}
                />
            )}
        </div>
    )
}

export default App

